var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{attrs:{"variant":"primary","title":"Download Template"},on:{"click":_vm.onClickcsvDownload}},[_c('i',{staticClass:"fa fa-download",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }